import React from 'react';
import PropTypes from 'prop-types';

const FinancialProductDetailsPaymentPlansContainer = ({ isSaved }) => {
  return <>{isSaved ? <></> : <></>}</>;
};

FinancialProductDetailsPaymentPlansContainer.propTypes = {
  isSaved: PropTypes.bool.isRequired
};

export default FinancialProductDetailsPaymentPlansContainer;
